import React from 'react'
import PropTypes from 'prop-types'
import CampaignEditorConfig from 'common/constants/CampaignEditorConfig'
import { LogosArea } from 'LiveBoard/components/shared/LogosArea'
import SearchContainer from 'LiveBoard/containers/SearchContainer'
import { Search } from './Search'
import { MenuContainer } from './Menu'
import { Banner, BANNER_TYPES } from 'LiveBoard/components/shared/Banner'
import { LIVE_BOARD_CLASSNAMES } from 'shared/constants'

import './style.css.scss'

const Header = ({ config, themeColorHex, textColor, banner }) => {
  const style = {borderBottom: `3px solid ${themeColorHex}`}
  const solidBackground = (
    config.background.show || !banner.show || banner.height == BANNER_TYPES.basic
  )

  return (
    <div className={`${LIVE_BOARD_CLASSNAMES.header} ${solidBackground ? 'solid' : ''}`} style={{color: textColor}}>
      {!solidBackground &&
        <div className='banner-wrapper'>
          <Banner
            config={banner}
            themeColorHex={themeColorHex}
            showContent={false}
            isMobile={true} />
        </div>}
      <div className='header-content' style={solidBackground ? style : null}>
        <LogosArea config={{ logo: config.logo, icon: config.icon, secondaryLogo: config.secondary_logo}}/>
        <div className='right-content'>
          <SearchContainer component={Search} solidBackground={solidBackground} />
          <MenuContainer solidBackground={solidBackground} textColor={textColor} />
        </div>
      </div>
    </div>
  )
}

Header.propTypes = {
  config: PropTypes.object.isRequired,
  banner: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired
}

export default Header
